import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MbIcon } from '@am/moebius';
import { NgClass } from '@angular/common';

@Component({
    selector: 'increment-input',
    templateUrl: './increment-input.component.html',
    styleUrls: ['./increment-input.component.scss'],
    standalone: true,
    imports: [NgClass, MbIcon],
})
export class IncrementInputComponent implements OnInit {
  @Input() set formGroup(form: UntypedFormGroup) {
    this.formControlInput = form;
  }

  @Input() set formName(name: string) {
    this.formNameInput = name;
  }

  @Input() disable = false;

  formControlInput: UntypedFormGroup;
  formNameInput = '';
  public value = 0;
  constructor() {}

  ngOnInit() {
    this.value = this.formControlInput.get(this.formNameInput).value;
  }

  changeValue(control: string) {
    const tempValue = this.value;

    if (!this.disable) {
      if (control === 'inc') {
        if (this.value < 10) {
          this.value++;
        }
      }

      if (control === 'dec') {
        if (this.value > 0) {
          this.value--;
        }
      }

      if (tempValue !== this.value) {
        this.formControlInput.get(this.formNameInput).setValue(this.value);
      }
    }
  }
}
